export var valuesLabelPosition = ["outside", "inside", "center", "top", "left", "right", "bottom"];
//# sourceMappingURL=LabelPosition.js.map